var PubSub = require("underpub-js");

var MobileNavOverlay = function(options){

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

MobileNavOverlay.prototype.init = function(){

	var self = this;

	PubSub.subscribe("mobileNavOverlay:show", function(){
		self.show();
	});

	PubSub.subscribe("mobileNavOverlay:hide", function(){
		self.hide();
	});

	this.options.$el.find('.close').on('click', function() {
		self.hide();
	});

};

MobileNavOverlay.prototype.show = function(){

	var self = this;

	this.options.$el.addClass("is-active");

	setTimeout(function() {
		$('body').addClass('disable-scroll');
	}, 500);

};

MobileNavOverlay.prototype.hide = function(){

	var self = this;

	this.options.$el.removeClass("is-active");

	$('body').removeClass('disable-scroll');

};

module.exports = MobileNavOverlay;
